import axios from "./axiosInstance"

const customizeformApi = {
    customize: (params) => axios.get("form/get-form", { params }),
    createSubmission: (formId, payload) => axios.post("form/create-submission", payload,{params: {
        formId
      }
    }
  )
}

export default customizeformApi;